module["exports"] = [
  'gmail.com',
  'yahoo.com',
  'gmail.co.id',
  'yahoo.co.id'
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/internet/free_email.js
// module id = 1024
// module chunks = 0